(ns app.front.view.admin.commands.change-config-path
  (:require [app.front.ui :as ui]
            [app.front.util :as futil]
            [app.front.view.group.admin.common :as acommon]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::workspace-id
  :-> ::workspace-id)

(rf/reg-sub ::options
  :-> ::options)

(rf/reg-event-db ::set-workspace-id
  (fn [db [_ ws-id]]
    (assoc db ::workspace-id ws-id)))

(rf/reg-event-fx ::get-options
  (fn [_ [_ ws-id]]
    {:comm/command {:command    :admin/get-config-path-options
                    :method     :post
                    :data       {:workspace/id ws-id}
                    :on-success [::get-options-success]}}))

(rf/reg-event-db ::get-options-success
  (fn [db [_ _ resp]]
    (assoc db ::options resp)))

(rf/reg-event-db ::select-config
  (fn [db [_ idx config]]
    (assoc db ::config-path
           (if (nil? config)
             (take idx (::config-path db))
             (-> (take idx (::config-path db))
                 (concat [config])
                 vec)))))

(rf/reg-event-db ::clear-options
  (fn [db _]
    (dissoc db ::options ::config-path)))

(rf/reg-event-fx ::submit
  (fn [_ [_ workspace-id [category work-type work-target]]]
    {:comm/command {:command    :admin/set-config-path
                    :method     :post
                    :data       (-> {:workspace/id workspace-id
                                     :category     (:id category)}
                                    (p/assoc-if :work-type (:id work-type))
                                    (p/assoc-if :work-target (:id work-target)))
                    :on-success [::submit-success]}}))

(rf/reg-event-fx ::submit-success
  (fn [_ _]
    {:fx [[:dispatch [:notifications/add :toast :success :success "The configuration has been changed"]]
          [:dispatch [::clear-options]]]}))

(rf/reg-sub ::config-path
  :-> ::config-path)

(defn- to-map [^js js]
  (js->clj js :keywordize-keys true))

(defn evt->map [^js js]
  (-> js .-selectedItem to-map))

(defn- config-selector [i options]
  [:div.mb-4
   (cc/combo-box {:id             "category-combo-box"
                  :items          options
                  :item-to-string (comp :name to-map)
                  :placeholder    (case i
                                    0 "Category"
                                    1 "Work type"
                                    2 "Work target")
                  :on-change      #(>evt [::select-config i (evt->map %)])})])

(defn view [match]
  [acommon/admin-page-v2
   (util/mmap {:title "Change the category, work type and work target for a workspace"}
              match)
   (let [ws-id   (<sub [::workspace-id])
         options (<sub [::options])]
     [:div
      [:section
       [:div.flex.items-end
        [ui/text-input {:id          "ws-id"
                        :light       true
                        :value       ws-id
                        :on-change   #(do (rf/dispatch-sync [::set-workspace-id (futil/tval %)])
                                          (>evt [::clear-options]))
                        :placeholder "CA-3539033-B-2024-1"
                        :label-text  "Workspace ID"}]
        (cc/button {:kind     :primary
                    :disabled (str/blank? ws-id)
                    :size     :field
                    :on-click #(>evt [::get-options ws-id])}
                   "Select workspace")]]
      (when options
        (let [[category work-type _ :as config-path] (<sub [::config-path])
              selection-done?                        (and (some? category)
                                                          (->> config-path
                                                               last
                                                               :children
                                                               empty?))]
          [:section
           (config-selector 0 options)
           (when (and category (seq (:children category)))
             [:div
              (config-selector 1 (:children category))
              (when (and work-type (seq (:children work-type)))
                (config-selector 2 (:children work-type)))])
           (when selection-done?
             (cc/button {:kind     :danger
                         :disabled false
                         :size     :field
                         :on-click #(>evt [::submit ws-id config-path])}
                        "Submit"))]))])])

(def route
  {:name        :view/admin.commands.change-config-path
   :own-layout? true
   :view        view})
